import { Component, OnInit, Input } from '@angular/core';
import { Cliente } from '../../cliente/cliente.model';
import { Parametric } from '../../cliente/parametric.model';
import { ApiService } from '../../core/api.service';

@Component({
  selector: 'app-usuario-datos-administrativos',
  templateUrl: './usuario-datos-administrativos.component.html',
  styleUrls: ['./usuario-datos-administrativos.component.scss']
})
export class UsuarioDatosAdministrativosComponent implements OnInit {
  @Input() cliente: Cliente;
  @Input() requiredSitIva = false;
  @Input() requiredCuitCuil = false;
  @Input() buttonClicked = false;

  situacionesIva: Parametric[];

  constructor(
    private apiService: ApiService
  ) { }

  ngOnInit() {
    this.getSituacionesIva();
  }

  async getSituacionesIva() {
    this.situacionesIva = await this.apiService.get(Parametric, Parametric.path + 'situaciones_iva/', null).toPromise();
  }



}



// WEBPACK FOOTER //
// ./src/app/shared-components/usuario-datos-administrativos/usuario-datos-administrativos.component.ts